export const constants: IConstants = {
  /**
   * Идентификатор для процесса встраивания ленты в конструкторе
   */
  INIT_EMBEDDING_FEED_STRING_NAME_PROCESS: 'initEmbeddingFeed',

  /**
   * Идентификатор инспектор-элемента
   */
  ID_INSPECTOR_ELEMENT: 'clickstream_analytics_feed_inspector_element_',

  /**
   * Идентификатор стилей для инспектор-элемента
   */
  ID_STYLES_INSPECTOR_ELEMENT: 'clickstream_analytics_styles_inspector_element_',

  /**
   * Идентификатор инспектор-элемента
   */
  ID_ANCHOR_ELEMENT: 'clickstream_analytics_feed_anchor_element_',

  /**
   * Сообщение пользователю при успешном альтернативном встраивании
   */
  MESSAGE_ON_SUCCESSFUL_ALTERNATIVE_EMBEDDING: 'Подтвердите расположение. Если Вам нравится выбранное место расположения - нажмите "Ок". Если хотите изменить место, то нажмите "Отмена" и выберите новое место, когда обновится страница',

  /**
   * Теги на которые не реагирует инспектор-элемент
   */
  EXCLUDE_TAGS: [
    'header',
    'nav',
    'footer',
    'a',
    'img',
    'button',
    'input',
    'textarea',
    'p',
    'label',
    'span',
    'strong',
    'b',
    'i',
    'small',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'ul',
    'li',
    'ol',
  ],

  /**
   * Разрешенный размер блока для встраивания
   */
  ALLOWED_BLOCK_SIZE_FOR_EMBEDDING: 301,

  /**
   * Сообщения при не успешном встраивании из-за превышения лимита размера блока
   */
  IS_NOT_LARGE_ENOUGH: {
    type: 'isNotLargeEnough',
    message: 'Выбранная область расположения имеет недостаточный размер для встраивания ленты. Пожалуйста, выберите другое место',
  },

  /**
   * Смещение от верхней границы якоря до его середины
   */
  ANCHOR_OFFSET: 24,
};
